<template>
  <div id="freeplay">
    <!--视频位置-->
    <div class="video"></div>
    <h2 class="title">
      <span class="tag">热门课程</span>
      幼儿《综合素质》单科
    </h2>
    <!--课程列表-->
    <div class="course-list">
      <dl class="cc">
        <dt>
          <h5>2022下 |《保教知识与能力》基础课</h5>
          <span class="arrow"></span>
        </dt>
        <dd>
          <a href="">
            <div class="left">
              <h6>01 | 综合素质直播1</h6>
              <div class="progress">
                <div class="bar"></div>
                <span>观看0%</span>
              </div>
            </div>
            <div class="right">
              <img src="../../assets/icon/videoplay_icon_play.png" alt="">
              播放
            </div>
            <span class="studied">已学习</span>
          </a>
          <a href="">
            <div class="left">
              <h6>01 | 综合素质直播1</h6>
              <div class="progress">
                <div class="bar"></div>
                <span>观看0%</span>
              </div>
            </div>
            <div class="right lock">
              <img src="../../assets/icon/videoplay_icon_play.png" alt="">
              <b>播放</b>
            </div>
            <span class="studied">已学习</span>
          </a>
          <a href="">
            <div class="left">
              <h6>01 | 综合素质直播1</h6>
              <div class="progress">
                <div class="bar"></div>
                <span>观看0%</span>
              </div>
            </div>
            <div class="right">
              <img src="../../assets/icon/videoplay_icon_play.png" alt="">
              播放
            </div>
            <span class="studied">已学习</span>
          </a>
        </dd>
      </dl>
      <dl class="cc">
        <dt class="active">
          <h5>2022下 | 《综合素质》基础课</h5>
          <span class="arrow"></span>
        </dt>
        <dd>
          <a href="" class="playing">
            <div class="left">
              <h6>01 | 综合素质直播1</h6>
              <div class="progress">
                <div class="bar"><i></i></div>
                <span>观看10%</span>
              </div>
            </div>
            <div class="right">
              <img src="../../assets/icon/videoplay_icon_pause.png" alt="">
              播放
            </div>
            <span class="today">今日免费</span>
          </a>
          <a href="">
            <div class="left">
              <h6>01 | 综合素质直播1</h6>
              <div class="progress">
                <div class="bar"></div>
                <span>观看0%</span>
              </div>
            </div>
            <div class="right">
              <img src="../../assets/icon/videoplay_icon_play.png" alt="">
              播放
            </div>
            <span class="tomorrow">明日预告</span>
          </a>
          <a href="">
            <div class="left">
              <h6>01 | 综合素质直播1</h6>
              <div class="progress">
                <div class="bar"></div>
                <span>观看0%</span>
              </div>
            </div>
            <div class="right lock">
              <img src="../../assets/icon/videoplay_icon_play.png" alt="">
              <b>播放</b>
            </div>
            <span class="studied">已学习</span>
          </a>
        </dd>
      </dl>
      <dl class="cc">
        <dt class="active">
          <h5>03 | 领学班</h5>
          <span class="arrow"></span>
        </dt>
        <dd>
          <a href="">
            <div class="left">
              <h6>01 | 综合素质直播1</h6>
              <div class="progress">
                <div class="bar"></div>
                <span>观看0%</span>
              </div>
            </div>
            <div class="right">
              <img src="../../assets/icon/videoplay_icon_play.png" alt="">
              播放
            </div>
            <span class="studied">已学习</span>
          </a>
          <a href="">
            <div class="left">
              <h6>01 | 综合素质直播1</h6>
              <div class="progress">
                <div class="bar"></div>
                <span>观看0%</span>
              </div>
            </div>
            <div class="right">
              <img src="../../assets/icon/videoplay_icon_play.png" alt="">
              播放
            </div>
            <span class="studied">已学习</span>
          </a>
          <a href="">
            <div class="left">
              <h6>01 | 综合素质直播1</h6>
              <div class="progress">
                <div class="bar"></div>
                <span>观看0%</span>
              </div>
            </div>
            <div class="right">
              <img src="../../assets/icon/videoplay_icon_play.png" alt="">
              播放
            </div>
            <span class="studied">已学习</span>
          </a>
        </dd>
      </dl>
    </div>
    <!--报名-->
    <div class="clearfix h108"></div>
    <a href="" class="fixed-bar">
      报名完整版课程学习
    </a>
    <div class="bg"></div>
  </div>
</template>

<script>
export default {
  name: 'FreePlay'
}
</script>

<style scoped lang="stylus">
  #freeplay
    .video
      width: 7.5rem
      height: 4.24rem
      background: url(../../assets/img/classsingle_banner.png) no-repeat center
      -webkit-background-size: 100%
      background-size: 100%
    h2.title
      position: relative
      height: 1.52rem
      padding: 0 .4rem
      background-color: #fff
      overflow: hidden
      font-size: .34rem
      color: #050505
      font-weight: 600
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      span.tag
        display: block
        width: 1.16rem
        height: .36rem
        line-height: .36rem
        background-color: #FF7052
        margin: .18rem 0 .16rem 0
        font-size: .24rem
        color: #fff
        text-align: center
    .course-list
      dl
        dt
          position: relative
          display: flex
          justify-content: space-between
          align-items: center
          width: 7.5rem
          height: 1.24rem
          padding: 0 .3rem
          background-color: #F7F7F7
          border-bottom: .02rem solid #CFD1D4
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          h5
            font-size: .3rem
            color: #292929
            font-weight: 600
            &::before
              content: ""
              position: absolute
              top: .5rem
              left: 0
              display: inline-block
              width: .08rem
              height: .28rem
              background-color: #FF7052
          span.arrow
            &::before
              content: ""
              position: relative
              top: -.04rem
              right: .1rem
              display: inline-block
              width: .1rem
              height: .1rem
              border-left: .03rem solid #666
              border-bottom: .03rem solid #666
              -webkit-transform: rotate(-45deg)
              -moz-transform: rotate(-45deg)
              -ms-transform: rotate(-45deg)
              -o-transform: rotate(-45deg)
              transform: rotate(-45deg)
          &.active
            border: none
            span.arrow
              &::before
                top: 0
                -webkit-transform: rotate(135deg)
                -moz-transform: rotate(135deg)
                -ms-transform: rotate(135deg)
                -o-transform: rotate(135deg)
                transform: rotate(135deg)
          &.active + dd
            display: block
        dd
          display: none
          width: 7.5rem
          padding: 0 .4rem
          background-color: #fff
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          a
            position: relative
            display: flex
            justify-content: space-between
            align-items: center
            width: 100%
            height: 1.68rem
            border-bottom: .02rem solid #E1E1E1
            padding: .22rem 0
            -webkit-box-sizing: border-box
            -moz-box-sizing: border-box
            box-sizing: border-box
            &:last-child
              border: none
            .left
              display: block
              width: 5.6rem
              h6
                font-size: .32rem
                color: #292929
              .progress
                display: flex
                justify-content: space-between
                align-items: center
                margin-top: .2rem
                .bar
                  position: relative
                  width: 4.7rem
                  height: .12rem
                  background-color: #E5E7EB
                  -webkit-border-radius: .06rem
                  -moz-border-radius: .06rem
                  border-radius: .06rem
                  i
                    position: absolute
                    top: 0
                    left: 0
                    display: inline-block
                    width: 10%
                    height: 100%
                    background-color: #FF7052
                    -webkit-border-radius: .06rem
                    -moz-border-radius: .06rem
                    border-radius: .06rem
                span
                  display: inline-block
                  width: .96rem
                  height: .26rem
                  line-height: .26rem
                  font-size: .18rem
                  color: #8A88A1
                  text-align: center
            .right
              position: relative
              display: block
              width: .84rem
              height: 1.22rem
              text-align: center
              img
                display: block
                width: .4rem
                height: .4rem
                margin: .4rem auto 0
              b
                font-weight: 500
              &.lock
                background: url(../../assets/icon/freeplay_icon_lock.png) no-repeat center
                -webkit-background-size: .38rem .44rem
                background-size: .38rem .44rem
                img, b
                  display: none
                & + .studied, & + .tomorrow, & + .today
                  display: none
            span.studied, span.tomorrow, span.today
              position: absolute
              top: 0
              right: 0
              display: block
              width: .84rem
              height: .32rem
              line-height: .32rem
              background-color: #3ED4B0
              font-size: .18rem
              color: #fff
              text-align: center
              -webkit-border-radius: 0 0 .04rem .04rem
              -moz-border-radius: 0 0 .04rem .04rem
              border-radius: 0 0 .04rem .04rem
            span.today
              background-color: #FF7052
            &.playing
              .left
                h6
                  color: #FF7052
                .progress
                  span
                    color: #FF7052
              .right
                color: #FF7052
    .clearfix.h108
      clear: both
      height: 1.08rem
      margin-top: .52rem
    a.fixed-bar
      position: fixed
      bottom: 0
      left: 0
      display: block
      width: 7.5rem
      height: 1.08rem
      line-height: 1.08rem
      background-color: #FF7052
      font-size: .28rem
      color: #fff
      text-align: center
    .bg
      position: fixed
      top: 0
      left: 0
      z-index: -1
      width: 100%
      height: 100%
      background-color: #F7F7F7
</style>



// WEBPACK FOOTER //
// src/components/play/FreePlay.vue